export default (id: string, result_id: string) => {
    typeof window !== 'undefined' &&
        typeof (window as any).nostojs === 'function' &&
        (window as any).nostojs((api) => {
            api.defaultSession()
                .recordAttribution('vp', id.split('/').slice(-1)[0], result_id)
                .done();
        });
};
